import { useEffect, useState } from "react";
import styles from "../../../homepage/pages/Calculators.module.css";
import { analytics, logEvent } from "../../../../firebase.js";

import { BlockMath, InlineMath } from "react-katex";

import Select from "../components/Select.js";
import InputNumber from "../components/InputNumber.js";
import Output from "../components/Output.js";

import { timberBending } from "../../utils/services/calculators.js";
import { Text, useToast } from "@chakra-ui/react";

function TimberBending({}) {
  const toast = useToast();
  // BENDING
  const [bendingInputs, setBendingInputs] = useState({
    forest_type: "Nativa",
    timber: "Coníferas",
    timber_class: "D20",
    timber_type: "Madeira serrada",
    load_class: "Permanente",
    moisture_class: "1 (≤ 65%)",
    l1_x: "",
    b: "",
    h: "",
    msd_x: "",
    msd_y: 0,
  });
  const [bendingOutputs, setBendingOutputs] = useState({
    fm_d: "",
    tens_mx_d: "",
    limit_1: "",
    limit_2: "",
    memorial: {},
  });

  function updateBendingInputs(name, value) {
    if (
      name === "forest_type" ||
      name === "timber" ||
      name === "timber_class" ||
      name === "timber_type" ||
      name === "load_class" ||
      name === "moisture_class"
    ) {
      if (value === "Nativa") {
        setBendingInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "D20",
        }));
      } else if (value === "Plantada") {
        setBendingInputs((prevInputs) => ({
          ...prevInputs,
          ["timber"]: "Coníferas",
        }));
        setBendingInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "C14",
        }));
      }
      if (value === "Coníferas") {
        setBendingInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "C14",
        }));
      } else if (value === "Folhosas") {
        setBendingInputs((prevInputs) => ({
          ...prevInputs,
          ["timber_class"]: "D18",
        }));
      }
      setBendingInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else if (value === "") {
      setBendingInputs((prevInputs) => ({
        ...prevInputs,
        [name]: value,
      }));
    } else {
      setBendingInputs((prevInputs) => ({
        ...prevInputs,
        [name]: parseFloat(value),
      }));
    }
    setBendingOutputs({
      fm_d: "",
      tens_mx_d: "",
      limit_1: "",
      limit_2: "",
    });
  }

  function onBendingCalculate() {
    if (
      bendingInputs["l1_x"] === "" ||
      bendingInputs["b"] === "" ||
      bendingInputs["h"] === "" ||
      bendingInputs["msd_x"] === ""
    ) {
      toast({
        title: "Preencha todos os campos",
        status: "warning",
        isClosable: true,
      });
    } else if (
      bendingInputs["l1_x"] === 0 ||
      bendingInputs["b"] === 0 ||
      bendingInputs["h"] === 0 ||
      bendingInputs["msd_x"] === 0
    ) {
      toast({
        title: "Os valores devem ser diferentes de 0",
        status: "warning",
        isClosable: true,
      });
    } else {
      timberBending(bendingInputs).then((response) => {
        setBendingOutputs(response["data"]);
        logEvent(analytics, "button_click", {
          button_name: "timber-bending-calculator-button",
        });
      });
    }
  }

  useEffect(() => {
    logEvent(analytics, "page_view", { page: "timber-bending-calculator" });
  }, []);

  return (
    <div className={styles.section} key={"header"}>
      <h1 className={styles.calculatorName}>Flexão Simples Normal:</h1>
      <div className={styles.calculator}>
        <div className={styles.inputs}>
          <div className={styles.inputRow}>
            <h3 className={styles.rowTitle}>Dados de entrada:</h3>
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Floresta"
              elements={["Nativa", "Plantada"]}
              unit=""
              onChange={(e) =>
                updateBendingInputs("forest_type", e.target.value)
              }
              value={bendingInputs["forest_type"]}
            />
            {bendingInputs["forest_type"] === "Plantada" && (
              <Select
                text="Madeira"
                elements={["Coníferas", "Folhosas"]}
                unit=""
                onChange={(e) => updateBendingInputs("timber", e.target.value)}
                value={bendingInputs["timber"]}
              />
            )}
          </div>
          <div className={styles.inputRow}>
            <Select
              text="Classe"
              elements={
                bendingInputs["forest_type"] === "Nativa"
                  ? ["D20", "D30", "D40", "D50", "D60"]
                  : bendingInputs["forest_type"] === "Plantada" &&
                      bendingInputs["timber"] === "Coníferas"
                    ? [
                        "C14",
                        "C16",
                        "C18",
                        "C20",
                        "C22",
                        "C24",
                        "C27",
                        "C30",
                        "C35",
                        "C40",
                        "C45",
                        "C50",
                      ]
                    : bendingInputs["forest_type"] === "Plantada" &&
                        bendingInputs["timber"] === "Folhosas"
                      ? ["D18", "D24", "D30", "D35", "D40", "D50", "D60", "D70"]
                      : []
              }
              unit=""
              onChange={(e) =>
                updateBendingInputs("timber_class", e.target.value)
              }
              value={bendingInputs["timber_class"]}
            />
            <Select
              text="Classe de umid."
              elements={["1 (≤ 65%)", "2 (≤ 75%)", "3 (≤ 85%)", "4 (> 85%)"]}
              unit=""
              onChange={(e) =>
                updateBendingInputs("moisture_class", e.target.value)
              }
              value={bendingInputs["moisture_class"]}
            />
          </div>
          <div className={styles.inputElement}>
            <Select
              text="Tipo"
              elements={[
                "Madeira serrada",
                "Madeira roliça",
                "Madeira lamelada colada (MLC)",
                "Madeira lamelada colada cruzada (MLCC)",
                "Madeira laminada colada (LVL)",
                "Madeira recomposta",
              ]}
              unit=""
              onChange={(e) =>
                updateBendingInputs("timber_type", e.target.value)
              }
              value={bendingInputs["timber_type"]}
            />
          </div>
          <div className={styles.inputElement}>
            <Select
              text="Classe de carregamento"
              elements={[
                "Permanente",
                "Longa duração",
                "Média duração",
                "Curta duração",
                "Instantânea",
              ]}
              unit=""
              onChange={(e) =>
                updateBendingInputs("load_class", e.target.value)
              }
              value={bendingInputs["load_class"]}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="L1"
              unit="cm"
              onChange={(e) => updateBendingInputs("l1_x", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="b"
              unit="cm"
              onChange={(e) => updateBendingInputs("b", e.target.value)}
            />
            <InputNumber
              text="h"
              unit="cm"
              onChange={(e) => updateBendingInputs("h", e.target.value)}
            />
          </div>
          <div className={styles.inputRow}>
            <InputNumber
              text="Msd,x"
              unit="tfm"
              onChange={(e) => updateBendingInputs("msd_x", e.target.value)}
            />
          </div>
        </div>
        <div className={styles.buttons}>
          <button
            className={styles.calculateButton}
            onClick={onBendingCalculate}
          >
            CALCULAR
          </button>
        </div>
        <div className={styles.outputs}>
          <h3 className={styles.rowTitle}>Resumo de resultados:</h3>
          <Output text="fm,d" value={bendingOutputs["fm_d"]} unit="MPa" />
          <h4>Momento em torno do eixo X</h4>
          <Output text="σMx,d" value={bendingOutputs["tens_mx_d"]} unit="MPa" />
          {bendingOutputs["tens_mx_d"] !== "" && (
            <h4 className={styles.rowDescription}>
              {bendingOutputs["tens_mx_d"].toFixed(2) +
                " ≤ " +
                bendingOutputs["fm_d"].toFixed(2) +
                " → "}
              {bendingOutputs["tens_mx_d"] <= bendingOutputs["fm_d"].toFixed(2)
                ? "OK!"
                : "NÃO OK!"}
            </h4>
          )}
          <h4>Estabilidade lateral</h4>
          {bendingOutputs["tens_mx_d"] !== "" &&
            (bendingInputs["l1_x"] / bendingInputs["b"] <=
            bendingOutputs["limit_1"] ? (
              <h4 className={styles.rowDescription}>
                {(bendingInputs["l1_x"] / bendingInputs["b"]).toFixed(2) +
                  " ≤ " +
                  bendingOutputs["limit_1"].toFixed(2) +
                  " → OK!"}
              </h4>
            ) : (
              <h4 className={styles.rowDescription}>
                {bendingOutputs["tens_mx_d"].toFixed(2) +
                  " ≤ " +
                  bendingOutputs["limit_2"].toFixed(2) +
                  " → "}
                {bendingOutputs["tens_mx_d"] <= bendingOutputs["limit_2"]
                  ? "OK!"
                  : "NÃO OK!"}
              </h4>
            ))}
        </div>
      </div>
      <div className={styles.memorial} key={"memorial"}>
        <h1>Memorial de Cálculo:</h1>
        {bendingOutputs["memorial"] &&
          Object.entries(bendingOutputs["memorial"]).map(
            ([className, subclasses]) => (
              <>
                <h2>{className}</h2>
                {Object.entries(subclasses).map(([subclassName, steps]) => (
                  <>
                    <h3>{subclassName}</h3>
                    {steps.map((step) => (
                      <>
                        <h4>{step["description"]}</h4>
                        <div className={styles.mathContainer}>
                          <BlockMath
                            math={step["formula"] + step["calculation"]}
                          />
                        </div>
                      </>
                    ))}
                  </>
                ))}
              </>
            )
          )}
      </div>
    </div>
  );
}

export default TimberBending;
